import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Advance } from 'src/app/models/advance';
import { Customer } from 'src/app/models/customer';
import { DigitalSignature } from 'src/app/models/digital-signature';
import { Loan } from 'src/app/models/loan';
import { OrderCheckList } from 'src/app/models/order-checklist';
import { OrderCompleteProcess } from 'src/app/models/order-complete-process';
import { Recollection } from 'src/app/models/recollection';
import { Reimbursement } from 'src/app/models/reimbursement';
import { ContractReturnResponseCompleteModel } from 'src/app/models/response/contract-return-response-complete-model';
import { OrderService } from 'src/app/services/order.service';
import { PosPrintDocumentsModalComponent } from 'src/app/shared/pos-print-documents-modal/pos-print-documents-modal.component';
import { ModalDialogType } from '../constants';

import { LoanService } from 'src/app/services/loan.service';
@Injectable({
  providedIn: 'root'
})
export class PosPrintDocumentsModalService {


  private modalRef?: BsModalRef<PosPrintDocumentsModalComponent>;
  constructor(private readonly modalService: BsModalService, private readonly orderService: OrderService, private readonly loanService: LoanService) { }

  show(order: OrderCompleteProcess, customer: Customer, digitalSignature: DigitalSignature) {
    return new Promise(async (resolve, reject) => {
      this.modalRef = this.modalService.show(PosPrintDocumentsModalComponent,
        {
          ignoreBackdropClick: true
        })

      this.modalRef.setClass(`modal-dialog ${ModalDialogType.PRIMARY} modal-md`)
      this.modalRef.content!.processedOrder = order;
      this.modalRef.content!.customer = customer;
      this.modalRef.content!.digitalSignature = digitalSignature;
      this.modalRef.content!.loadInfo();
      resolve(true);
    });
  }

  async showPrintLoanDocuments(loan: Loan, customer: Customer, customerStatus: string): Promise<void> {
    let processedOrder = new OrderCompleteProcess();
    let digitalSignature = new DigitalSignature();
    if (loan.orderCode) {
      processedOrder = (await this.orderService.readerOrderCompleteProcess(loan.orderCode).toPromise()).response;
      digitalSignature = (await this.orderService.readDigitalSignatureByOrderCode(loan.orderCode).toPromise()) || new DigitalSignature();
    }
    else {
      processedOrder.loans.push(loan);
      digitalSignature = (await this.loanService.readDigitalSignature(loan.contractNumber).toPromise()).response;
    }
    this.modalRef = this.modalService.show(PosPrintDocumentsModalComponent,
      {
        ignoreBackdropClick: true,
        class: `modal-dialog ${ModalDialogType.PRIMARY} modal-md`,
        initialState: {
          loanObj: loan,
          customer,
          isOnlyCreditsDocuments: true,
          processedOrder,
          customerStatus,
          digitalSignature
        }
      });
  }

  async showPrintRecollectionDocuments(recollection: Recollection | undefined, repairshopInvoice: { fullNumber: string, netTotal: number, code: string, salesOrg: string }, customer: Customer | undefined): Promise<void> {
    this.modalRef = this.modalService.show(PosPrintDocumentsModalComponent,
      {
        ignoreBackdropClick: true,
        class: `modal-dialog ${ModalDialogType.PRIMARY} modal-md`,
        initialState: {
          customer,
          isForPrintRecollectionDocuments: true,
          recollection,
          recollectionInvoicesObj: repairshopInvoice,
        }
      });
  }

  async showPrintContractReturnDocuments(contractReturnResponseComplete: ContractReturnResponseCompleteModel): Promise<void> {
    this.modalRef = this.modalService.show(PosPrintDocumentsModalComponent,
      {
        ignoreBackdropClick: true,
        class: `modal-dialog ${ModalDialogType.PRIMARY} modal-md`,
        initialState: {
          isForPrintContractReturnDocuments: true,
          contractReturnResponseComplete
        }
      });
  }

  async showPrintAdvanceDocuments(advance: Advance) {
    this.modalRef = this.modalService.show(PosPrintDocumentsModalComponent,
      {
        ignoreBackdropClick: true,
        class: `modal-dialog ${ModalDialogType.PRIMARY} modal-md`,
        initialState: {
          isForAdvanceDocuments: true,
          advance
        }
      });
  }

  showPrintReimbursement(reimbursement: Reimbursement) {
    this.modalRef = this.modalService.show(PosPrintDocumentsModalComponent,
      {
        ignoreBackdropClick: true,
        class: `modal-dialog ${ModalDialogType.PRIMARY} modal-md`,
        initialState: {
          isForReimbursement: true,
          reimbursement
        }
      });
  }


  async showPrintOrderChecklist(orderChecklist: OrderCheckList, customer: Customer): Promise<void> {
    this.modalRef = this.modalService.show(PosPrintDocumentsModalComponent,
      {
        ignoreBackdropClick: true,
        class: `modal-dialog ${ModalDialogType.PRIMARY} modal-md`,
        initialState: {
          orderChecklist: orderChecklist,
          customer,
          isForOrderChecklist: true
        }
      });


  }
}
